import Core from '@/Calendar/core.vue';
import MonthView from '@/Calendar/components/MonthView.vue';
import WeekView from '@/Calendar/components/WeekView.vue';
import MonthSelectPopup from '@/Calendar/components/MonthSelectPopup.vue';
import { unixFormatted } from '@/util/dates';
import { defineComponent, ref, computed, watch, createElement } from '@vue/composition-api';
export default defineComponent({
    components: {
        Core,
        MonthView,
        WeekView,
        MonthSelectPopup
    },
    props: {
        weekTimeline: {
            type: Object,
            default: () => ({})
        },
        allVenueSpaces: {
            type: Array,
            default: () => []
        },
        dateData: {
            type: [Array, Object],
            default: () => []
        },
        slots: {
            type: Object,
            required: true
        },
        workingTime: {
            type: Array,
            default: () => []
        },
        fromToLabels: {
            type: Array,
            default: () => []
        },
        mode: {
            type: String,
            default: 'month'
        },
        showTitle: Boolean,
        title: {
            type: Object,
            default: () => ({
                controls: null,
                left: 'Title'
            })
        },
        size: { type: [String], default: 'normal' },
        startDate: {
            type: [Date, String],
            default: null
        },
        wtMode: {
            type: Boolean,
            default: false
        },
        spacesCalendarData: {
            type: Array,
            default: () => []
        }
    },
    setup(props, context) {
        const { emit } = context;
        const selectedDay = ref('');
        const transitionName = 'fade';
        const month = MonthView;
        const popup = MonthSelectPopup;
        const week = WeekView;
        const getComponentMode = computed(() => props.mode === 'month' ? month : week);
        watch(() => selectedDay.value, () => {
            if (props.slots.slotFrom) {
                globalThis.$store.commit('$_calendar/SET_SELECTED_CALENDAR_DAY', unixFormatted(props.slots.slotFrom, 'YYYY-MM-DD'));
            }
            else {
                globalThis.$store.commit('$_calendar/SET_SELECTED_CALENDAR_DAY', selectedDay.value);
            }
        }, { immediate: true });
        const onMonthDayClick = () => {
            // When a day is clicked in a Month View, the calendar mode for the space page must be set to `week`
            // See parent `CalendarBlock.vue`
            emit('month-day-clicked');
        };
        const onMonthChange = (val) => {
            if (val) {
                emit('monthChange', val.now);
                selectedDay.value = val.now.full;
            }
        };
        const selectedDayNum = (val) => {
            emit('dayNum', val);
        };
        // Selected Date Object - month mode props { year, title }, week mode {year, title }
        const renderHeader = ({ prev, next, selectedDate, getSelectedDay }) => {
            const arrowLeft = createElement('i', {
                class: 'fa-solid fa-arrow-left fa-xs arrows'
            });
            const prevButton = createElement('div', {
                class: 'ui-calendar-control',
                attrs: { role: 'button' },
                on: { click: prev }
            }, [arrowLeft]);
            const arrowRight = createElement('i', {
                class: 'fa-solid fa-arrow-right fa-xs arrows'
            });
            const nextButton = createElement('div', {
                class: 'ui-calendar-control',
                attrs: { role: 'button' },
                on: { click: next }
            }, [arrowRight]);
            const popupElement = createElement(popup, {
                props: { info: selectedDate, currentDate: selectedDay.value },
                on: {
                    'popup-change-month': function (date) {
                        // YYYY-MM-DD string
                        getSelectedDay(date);
                    }
                }
            });
            const dateText = createElement('div', { class: 'header-center' }, [
                popupElement
            ]);
            return createElement('div', { class: 'calendar-controls' }, [
                prevButton,
                dateText,
                nextButton
            ]);
        };
        return {
            getComponentMode,
            month,
            popup,
            selectedDay,
            transitionName,
            week,
            onMonthChange,
            onMonthDayClick,
            renderHeader,
            selectedDayNum
        };
    }
});
